import      '../../styles/loader.css'


export  default     function    Loading({height}){

    return(
        <div    className='load__container' style={{width:height}}>
        <div    className='container'>
        <div ></div>
        <div></div>
        </div>
        </div>
    )
}